(() => {
  'use strict';
  document.documentElement.classList.add('js');
  const root = document.body.dataset.rootUrl || '/';
  const status = document.getElementById('ThemeStatus');
  const savedKey = 'hooded-shopify-saved';
  let busyCart = false;
  let wishlistRequest = 0;
  const announce = message => { if (status) status.textContent = message; };
  const url = path => root + path;

  function savedHandles() {
    try {
      const value = JSON.parse(localStorage.getItem(savedKey) || '[]');
      return Array.isArray(value) ? value.filter(v => typeof v === 'string' && /^[a-z0-9-]+$/.test(v)).slice(0,100) : [];
    } catch { return []; }
  }

  function syncSavedButtons() {
    const saved = savedHandles();
    document.querySelectorAll('[data-save-product]').forEach(button => {
      button.setAttribute('aria-pressed', String(saved.includes(button.dataset.saveProduct)));
    });
  }

  function toggleSaved(handle) {
    if (!/^[a-z0-9-]+$/.test(handle || '')) return;
    const saved = savedHandles();
    const exists = saved.includes(handle);
    try { localStorage.setItem(savedKey, JSON.stringify(exists ? saved.filter(h=>h!==handle) : [...saved,handle].slice(-100))); }
    catch { announce('Your browser could not save this piece.'); return; }
    syncSavedButtons();
    announce(exists ? 'Piece removed from favorites.' : 'Piece saved on this device.');
  }

  async function jsonRequest(path, options={}) {
    const response = await fetch(url(path), { credentials:'same-origin', ...options, headers:{ Accept:'application/json', ...options.headers } });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'That change could not be completed. Please review your bag and try again.');
    return data;
  }

  function replaceCart(html) {
    if (typeof html !== 'string') return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('.cart-panel-content');
    const current = document.querySelector('#CartDialog .cart-panel-content');
    if (!next || !current) return false;
    current.replaceWith(next);
    const count = next.dataset.cartItems || '0';
    document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=count;});
    return true;
  }

  async function refreshCart() {
    const response = await fetch(url('?sections=cart-panel'), {credentials:'same-origin',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Your bag could not be refreshed. Open the full bag to review it.');
    const sections = await response.json();
    if (!replaceCart(sections['cart-panel'])) throw new Error('Your bag changed, but the preview could not refresh. Open the full bag to review it.');
  }

  function cartError(message) {
    const error = document.querySelector('[data-cart-error]');
    if (error) { error.textContent=message; error.hidden=false; }
    announce(message);
  }

  function openDialog(id, trigger) {
    const dialog=document.getElementById(id);
    if (typeof HTMLDialogElement === 'undefined' || !(dialog instanceof HTMLDialogElement)) return false;
    if (typeof dialog.showModal !== 'function') return false;
    dialog.returnFocus=trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();
    if (id==='SearchDialog') dialog.querySelector('input[type=search]')?.focus();
    if (id==='SavedDialog') renderSaved();
    return true;
  }

  document.querySelectorAll('dialog').forEach(dialog=>{
    dialog.addEventListener('click', event=>{
      if (event.target!==dialog) return;
      const rect=dialog.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom) dialog.close();
    });
    dialog.addEventListener('close',()=>{
      if (dialog.returnFocus?.isConnected) dialog.returnFocus.focus();
    });
  });

  document.addEventListener('click', async event=>{
    const target=event.target instanceof Element ? event.target : null;
    if (!target) return;
    const close=target.closest('[data-close-dialog]');
    if (close) { close.closest('dialog')?.close(); return; }
    const opener=target.closest('[data-open-dialog]');
    if (opener && openDialog(opener.dataset.openDialog, opener)) {
      event.preventDefault();
      if(opener.dataset.openDialog==='CartDialog') {
        try { await refreshCart(); } catch(error) { cartError(error.message); }
      }
      return;
    }
    const save=target.closest('[data-save-product]');
    if(save){event.preventDefault();toggleSaved(save.dataset.saveProduct);return;}
    const removeSaved=target.closest('[data-remove-saved]');
    if(removeSaved){toggleSaved(removeSaved.dataset.removeSaved);renderSaved();return;}
    const gallery=target.closest('[data-gallery-image]');
    if(gallery){
      const main=document.getElementById('ProductMainImage');
      if(main){event.preventDefault();main.removeAttribute('srcset');main.src=gallery.dataset.galleryImage;main.alt=gallery.dataset.alt||'';}
      return;
    }
    const quantity=target.closest('[data-cart-change]');
    if(quantity){
      if(busyCart)return;
      const amount=Number(quantity.dataset.quantity);
      if(!Number.isInteger(amount)||amount<0)return;
      busyCart=true;
      const dialog=document.getElementById('CartDialog');
      const controls=dialog.querySelectorAll('[data-cart-change], button[name=checkout]');
      controls.forEach(button=>{button.disabled=true;});
      try{
        const data=await jsonRequest('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:quantity.dataset.cartChange,quantity:amount,sections:['cart-panel'],sections_url:root})});
        if(!replaceCart(data.sections?.['cart-panel']))await refreshCart();
        announce('Your bag has been updated.');
        dialog.querySelector('[data-close-dialog]')?.focus();
      }catch(error){cartError(error.message);}
      finally{busyCart=false;document.querySelectorAll('#CartDialog [data-cart-change], #CartDialog button[name=checkout]').forEach(button=>{button.disabled=false;});}
    }
  });

  document.addEventListener('change',event=>{
    const select=event.target;
    if(!(select instanceof HTMLSelectElement))return;
    if(select.matches('[data-auto-submit]')){select.form?.requestSubmit();return;}
    if(!select.matches('[data-variant-select]'))return;
    const option=select.selectedOptions[0];
    if(!option || !option.value || option.disabled)return;
    const product=select.closest('.detail-copy');
    const addButton=product.querySelector('[name=add]');if(addButton){const available=option.dataset.available==='true';addButton.disabled=!available;addButton.querySelector('[data-add-label]').textContent=available?'Add to bag':'Sold out';}
    const price=product.querySelector('[data-product-price]');
    if(price)price.textContent=option.dataset.price||'';
    const compare=product.querySelector('[data-compare-price]');
    if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
    const image=document.getElementById('ProductMainImage');
    if(image&&option.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;}
    const currentUrl=new URL(location.href);currentUrl.searchParams.set('variant',option.value);history.replaceState({},'',currentUrl);
  });

  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||!form.matches('[data-product-form]'))return;
    if(typeof HTMLDialogElement==='undefined'||typeof HTMLDialogElement.prototype.showModal!=='function')return;
    event.preventDefault();
    if(!form.reportValidity()||form.dataset.busy==='true')return;
    form.dataset.busy='true';
    const button=form.querySelector('[name=add]');
    const label=button.querySelector('[data-add-label]');
    const errorBox=form.querySelector('[data-form-error]');
    errorBox.hidden=true;
    button.disabled=true;
    const labelBefore=label.textContent;label.textContent='Adding…';
    try{
      const body=new FormData(form);body.set('sections','cart-panel');body.set('sections_url',root);
      const data=await jsonRequest('cart/add.js',{method:'POST',body});
      openDialog('CartDialog',button);
      try{if(!replaceCart(data.sections?.['cart-panel']))await refreshCart();announce('Added to your bag.');}
      catch(error){cartError(error.message);}
    }catch(error){errorBox.textContent=error.message+' If the connection was interrupted, check your bag before adding again.';errorBox.hidden=false;}
    finally{form.dataset.busy='false';button.disabled=false;label.textContent=labelBefore;}
  });

  async function renderSaved(){
    const target=document.querySelector('[data-saved-items]');
    if(!target)return;
    const currentRequest=++wishlistRequest;
    const handles=savedHandles();
    target.replaceChildren();
    const note=document.createElement('p');note.className='empty-state';note.textContent=handles.length?'Loading your favorites…':'Tap the heart on a piece to save it here.';target.append(note);
    if(!handles.length)return;
    const results=await Promise.all(handles.map(async handle=>{
      try{return {handle,product:await jsonRequest('products/'+encodeURIComponent(handle)+'.js')};}
      catch{return {handle,product:null};}
    }));
    if(currentRequest!==wishlistRequest)return;
    target.replaceChildren();
    for(const {handle,product} of results){
      const row=document.createElement('article');row.className='saved-product';
      const content=document.createElement('div');
      if(product){
        if(product.featured_image){const image=document.createElement('img');image.src=product.featured_image;image.alt=product.title;image.loading='lazy';image.width=92;image.height=92;row.append(image);}
        const link=document.createElement('a');link.href=url('products/'+encodeURIComponent(handle));link.textContent=product.title;content.append(link);
        const availability=document.createElement('p');availability.textContent=product.available?'Choose your color and size':'Currently sold out';content.append(availability);
      }else{const label=document.createElement('p');label.textContent='This saved piece is unavailable.';content.append(label);}
      const remove=document.createElement('button');remove.className='text-link';remove.textContent='Remove';remove.dataset.removeSaved=handle;content.append(remove);row.append(content);target.append(row);
    }
  }
  window.addEventListener('storage',event=>{if(event.key===savedKey)syncSavedButtons();});
  document.addEventListener('shopify:section:load',syncSavedButtons);
  syncSavedButtons();
})();
